import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='life-insurance-faq-surrender-a-policy'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'
          align='center'>
          Surrender a Policy
        </Typography>
        <Typography nextElement='typography'>
          When you surrender a policy, you agree to receive the cash value of the policy. You can either
          receive it in one lump sum or in regularly scheduled payments over a specific period of time. The
          frequency and amount of the payments are determined by the settlement plan you select.
        </Typography>
        <Typography nextElement='typography'>
          Surrendering a policy could have tax or financial implications. Consult your Northwestern Mutual
          representative or tax adviser to determine if surrendering a policy is right for your financial
          situation.
        </Typography>
        <Typography nextElement='typography'>
          Some policies will incur a surrender charge to cover administrative costs. See your policy provisions for details.
        </Typography>
        <Typography disableBottomPadding>
          Also see: Settlement Plans
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
